import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import useTranslation from 'next-translate/useTranslation'

const ReadNotificationDot = () => {
  const { t } = useTranslation('common')
  return (
    <StyledReadDot
      aria-label={t('notification-unread')}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    />
  )
}

export default ReadNotificationDot

const StyledReadDot = styled(motion.div)(({ theme }) => ({
  position: 'absolute',
  top: 10,
  right: 8,
  userSelect: 'none',
  width: 4,
  height: 4,
  background: theme.colors.icon.alert,
  borderRadius: theme.radii[2],
  border: '2px solid white',
  boxSizing: 'content-box'
}))
